export function locationHref(slug: string) {
  switch (slug) {
    case "sohna-road-gurugram":
      return "/locations/sohna-road-gurugram" as const;
    case "indirapuram-ghaziabad":
      return "/locations/indirapuram-ghaziabad" as const;
    case "haridwar":
      return "/locations/haridwar" as const;
    case "agra":
      return "/locations/agra" as const;
    case "muzaffarnagar":
      return "/locations/muzaffarnagar" as const;
    default:
      return "/locations" as const;
  }
}
